<template>
  <div class="card">
    <div class="card-header">
      <h2>Change password</h2>
    </div>
    <div class="card-body">
      <form ref="password_form" @submit.prevent="handleChangePassword">
        <div class="position-relative my-4">
          <base-input
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            name="new_password"
            autocomplete="on"
            class=""
            label="Password"
            :placeholder="showPassword ? 'New Password' : '********'"
          />
          <button 
            type="button"
            class="toggle-password-btn"
            @click="togglePassword"
            >
            <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          </button>
        </div>
        <validation-error :errors="errors.password" class="error-field" />  
        <div class="position-relative my-4">
          <base-input
            v-model="password_confirmation"
            :type="showConfirmPassword ? 'text' : 'password'"
            name="confirm_password"
            label="Confirm password"
            autocomplete="on"
            class=""
            :placeholder="showConfirmPassword ? 'Confirm Password' : '********'"
          />
          <button 
              type="button"
              class="toggle-password-btn"
              @click="toggleConfirmPassword"
            >
              <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          </button>
        </div>
        <validation-error :errors="errors.password_confirmation" class="error-field" />
        <div class="my-4">
          <base-button type="button" class="submit" native-type="submit">
            Save
          </base-button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import BaseInput from "@/components/Form/Input/BaseInput.vue";
import BaseButton from "@/components/ui/Button/BaseButton.vue";
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ui/ValidationError.vue";

export default {
  name: "UserPasswordCard",

  components: {
    BaseInput,
    BaseButton,
    ValidationError,
  },

  mixins: [formMixin],

  props: {
    user: Object,
  },

  data() {
    return {
      errors: {},
      password: null,
      password_confirmation: null,
      showPassword: false,
      showConfirmPassword: false,
    };
  },

  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },

    async handleChangePassword() {
      if (!this.password || !this.password_confirmation) {
        this.$notify({
          type: "danger",
          message: "Preencha todos os campos!",
        });
        return false;
      }

      this.user.password = this.password;
      this.user.password_confirmation = this.password_confirmation;

      try {
        await this.$store.dispatch("profile/update", this.user);
        this.$refs["password_form"].reset();

        // this.resetApiValidation();
        this.errors = {};
        this.$notify({
          type: "success",
          message: "Senha alterada!.",
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Confira os dados!",
        });
        this.errors = error.response.data.errors;
        // this.setApiValidation(error.response.data.errors);
      }
    },
  },
};
</script>

<style>

.error-field{
  position: relative;
  bottom: -25px;
  left: 0;
}
  
.position-relative {
  position: relative;
}

.toggle-password-btn {
  position: absolute;
  right: 12px;
  top: calc(50% + 17px);
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #8898aa;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.toggle-password-btn:hover {
  color: #525f7f;
}

</style>
